export default __webpack_public_path__ + "static/media/BG3-1.cc695bde.jpg";